import { BrowserModule } from '@angular/platform-browser';
import {
  SpeechSynthesisModule,
} from '@kamiazya/ngx-speech-synthesis';

import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
// import { NgModule} from '@angular/core';
import { HttpClientModule} from '@angular/common/http';
import { CommonModule, DatePipe} from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HechoIrregularComponent } from './pages/denuncia/hecho-irregular/hecho-irregular.component';
import { DatosGeneralComponent } from './pages/datos-general/datos-general.component';

import {MatInputModule} from '@angular/material/input';
import {MatTooltipModule} from '@angular/material/tooltip';
import { DenunciaContenedorComponent } from './pages/denuncia/denuncia-contenedor/denuncia-contenedor.component';

import { EntidadHechoComponent } from './pages/denuncia/entidad-hecho/entidad-hecho.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { FuncionarioInvolucradoComponent } from './pages/denuncia/Funcionario/funcionario-involucrado/funcionario-involucrado.component';
import { EmpresaInvolucradaComponent } from './pages/denuncia/empresa/empresa-involucrada/empresa-involucrada.component';
import { PruebaHechoComponent } from './pages/denuncia/prueba-hecho/prueba-hecho.component';
import { FormularioWebComponent } from './pages/formulario-web/formulario-web.component';

import { ModalMontoComponent } from './pages/denuncia/modal/modal-monto/modal-monto.component';

import { ModalEmpresaComponent } from './pages/denuncia/empresa/modal-involucrada/modal-empresa/modal-empresa.component';

import { ContenedorDenuncianteComponent } from './pages/Denunciante/Contenedor/contenedor-denunciante.component';
import { PersonaJuridicaComponent } from './pages/Denunciante/PersonaJuridica/persona-juridica.component';
import { PersonaNaturalComponent } from './pages/Denunciante/PersonaNatural/persona-natural.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ContenedorMpComponent } from './pages/MedidasProt/contenedor-mp/contenedor-mp.component';

import { ModalNotificacionComponent } from './pages/Denunciante/ModalNotificacion/modal-notificacion.component';
import {MatDialogModule} from '@angular/material/dialog';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { ModalMensajeComponent } from './pages/General/modal-mensaje/modal-mensaje.component';
import { ModalBusqObrpuComponent } from './pages/ObraPublica/modal-busq-obrpu/modal-busq-obrpu.component';
import { ModalIrregInfobrasComponent } from './pages/ObraPublica/modal-irreg-infobras/modal-irreg-infobras.component';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};
import { RecaptchaModule } from 'ng-recaptcha';
import { PanelPrincipalComponent } from './pages/Dashboard/panel-principal/panel-principal.component';
import { BodyOpcionesComponent } from './pages/Dashboard/body-opciones/body-opciones.component';
import { BodyBusquedaComponent } from './pages/Dashboard/body-busqueda/body-busqueda.component';
import { MatTableModule, MAT_DATE_LOCALE } from '@angular/material' ;
import { MatPaginatorModule } from '@angular/material';
import { CookieService } from 'ngx-cookie-service';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatMomentModule } from '@angular-material-components/moment-adapter';
import { NgxSpinnerModule } from 'ngx-spinner';



import {MatIconModule} from '@angular/material/icon';


const router: Routes = [
  // component: FormularioWebComponent},
  { path: 'AtencionDenuncias',
  component: PanelPrincipalFwComponent},
  { path: 'AtencionDenuncias/' + DscPathFwExt + '/:idInstancia',
  component: PanelPrincipalFwComponent},
   { path: 'accedeatudenuncia',
   component: AccedaDenunciaComponent},
   { path: 'olvidoClave',
   component: OlvidoClaveComponent},
   { path: 'denunciar',
   component: FormularioWebComponent},
   { path: 'denunciar/' + DscPathFwExt + '/:idInstancia',
   component: FormularioWebComponent},
   { path: 'registroexitoso',
   component: RegistroExitosoComponent},
   { path: 'registroborradorexitoso',
   component: RegistroExitosoComponent},
   { path: '',   redirectTo: '/denunciar', pathMatch: 'full' },
   // { path: '**', redirectTo: '/AtencionDenuncias/' + DscPathFwExt + '/:idInstancia', pathMatch: 'full'  }

];
import { ModalEntidadComponent } from './pages/denuncia/entidad-hecho/modal-entidad/modal-entidad.component';
import { ModalFuncionarioComponent } from './pages/denuncia/Funcionario/modal-funcionario/modal-funcionario/modal-funcionario.component';
import { ModalMpComponent } from './pages/MedidasProt/modal-mp/modal-mp.component';
import { ModalContratacionComponent } from './pages/denuncia/contratacion/modal-contratacion/modal-contratacion.component';
import { ModalRegistroObraComponent } from './pages/ObraPublica/modal-registro-obra/modal-registro-obra.component';
import { InstanciaComponent } from './pages/denuncia/instancia/instancia.component';
import { ModalHechoIrregularComponent } from './pages/ObraPublica/modal-hecho-irregular/modal-hecho-irregular.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EvalinfRegfurComponent } from './pages/evalinf-regfur/evalinf-regfur.component';

import { DgHojaEvalComponent } from './pages/datos-general/dg-hoja-eval/dg-hoja-eval.component';
import { EvidenciasComponent } from './pages/denuncia/evidencias/evidencias.component';
// import { ModalAntecedenteComponent } from './pages/evalInf-regfur/modal-antecedente/modal-antecedente.component';
import { AntecedentesFurComponent } from './pages/evalinf-regfur/antecedentes-fur/antecedentes-fur.component';
import { ModalAntecedenteComponent } from './pages/evalinf-regfur/modal-antecedente/modal-antecedente.component';
// import { AntecedentesFurComponent } from './pages/antecedentes-fur/antecedentes-fur.component';
import { FurComponent } from './pages/fur/fur.component';
import { ModalInstanciaComponent } from './pages/denuncia/instancia/modal-instancia/modal-instancia.component';
import { BodyRegistroComponent } from './pages/Dashboard/body-registro/body-registro.component';
import { BodyDatosGeneralComponent } from './pages/Dashboard/body-datos-general/body-datos-general.component';
import { BodyDatosExpedienteComponent } from './pages/Dashboard/body-datos-expediente/body-datos-expediente.component';
import { BodyDatosOtrosComponent } from './pages/Dashboard/body-datos-otros/body-datos-otros.component';
import { ContenedorAsigInfoComponent } from './pages/Dashboard/contenedor-asig-info/contenedor-asig-info.component';
import { RegistroDocumentoComponent } from './pages/registro-documento/registro-documento.component';
import { AsignarInformacionComponent } from './pages/asignar-informacion/asignar-informacion.component';
import { DatosRegistroComponent } from './pages/asignar-informacion/datos-registro/datos-registro.component';
import { DgAsigRespComponent } from './pages/General/dg-asig-resp/dg-asig-resp.component';
import { AsignaResponsableComponent } from './pages/General/asigna-responsable/asigna-responsable.component';
import { ContenedorWebComponent } from './pages/formulario-web/contenedor-web/contenedor-web.component';
import { AgrupacionComponent } from './pages/Denunciante/agrupacion/agrupacion.component';
import { ExpedienteComponent } from './pages/MedidasProt/expediente/expediente.component';
import { EvaluacionFudComponent } from './pages/evalinf-regfur/evaluacion-fud/evaluacion-fud.component';
import { DocAGenerarComponent } from './pages/General/doc-a-generar/doc-a-generar.component';
import { DocumentosEmitidosComponent } from './pages/General/documentos-emitidos/documentos-emitidos.component';
import { NavModalComponent } from './pages/General/nav-modal/nav-modal.component';
import { BusqEntidadComponent } from './pages/general/busq-entidad/busq-entidad.component';
import { EncuestaComponent } from './pages/Denunciante/encuesta/encuesta.component';
import { ModalEncuestaComponent } from './pages/Denunciante/modal-encuesta/modal-encuesta.component';
import { ModalGuardarComponent } from './pages/formulario-web/modal-guardar/modal-guardar.component';
import { PanelPrincipalFwComponent } from './pages/formulario-web/panel-principal-fw/panel-principal-fw.component';
import { CabeceraPpFwComponent } from './pages/formulario-web/cabecera-pp-fw/cabecera-pp-fw.component';
import { AccedaDenunciaComponent } from './pages/formulario-web/acceda-denuncia/acceda-denuncia.component';
import { DatosEmpresaDenuncComponent } from './pages/Denunciante/datos-empresa-denunc/datos-empresa-denunc.component';
import { DenuncianteCongresistaComponent } from './pages/Denunciante/denunciante-congresista/denunciante-congresista.component';
import { PpPruebaComponent } from './pages/formulario-web/pp-prueba/pp-prueba.component';
import { ModalRepLegalComponent } from './pages/Denunciante/modal-rep-legal/modal-rep-legal.component';
import { DcianteEntidadPubComponent } from './pages/Denunciante/dciante-entidad-pub/dciante-entidad-pub.component';
import { ModalDatosEmpresaComponent } from './pages/denuncia/empresa/modal-datos-empresa/modal-datos-empresa.component';
import { ModalVerRepreLegalComponent } from './pages/denuncia/empresa/modal-ver-repre-legal/modal-ver-repre-legal.component';
import { ModalSeguimientoPpComponent } from './pages/formulario-web/modal-seguimiento-pp/modal-seguimiento-pp.component';
import { ModalRegContratacionComponent } from './pages/denuncia/modal-reg-contratacion/modal-reg-contratacion.component';
import { ModalBusqContratacionComponent } from './pages/denuncia/modal-busq-contratacion/modal-busq-contratacion.component';
import { ModalRegHechoirreContrComponent } from './pages/denuncia/modal-reg-hechoirre-contr/modal-reg-hechoirre-contr.component';
import { ModalDetalleContratacionComponent } from './pages/denuncia/modal-detalle-contratacion/modal-detalle-contratacion.component';
import { FechaHoraMaterialComponent } from './pages/General/fecha-hora-material/fecha-hora-material.component';
import { DatosGenFurComponent } from './pages/fur/datos-gen-fur/datos-gen-fur.component';
import { ModalRegCargoComponent } from './pages/evalinf-regfur/modal-reg-cargo/modal-reg-cargo.component';
import { ModalGenerarDocSgdComponent } from './pages/evalinf-regfur/modal-generar-doc-sgd/modal-generar-doc-sgd.component';
import { ModalBusqFurComplComponent } from './pages/evalinf-regfur/modal-busq-fur-compl/modal-busq-fur-compl.component';
import { DscPathFwExt } from './general/variables';
import { ModalTerminosComponent } from './pages/formulario-web/modal-terminos/modal-terminos/modal-terminos.component';
import { ModalInstruccionesMpComponent } from './pages/MedidasProt/modal-instrucciones-mp/modal-instrucciones-mp.component';
import { ModalAccesoComponent } from './pages/formulario-web/modal-acceso/modal-acceso.component';
import { InfoComplementariaWebComponent } from './pages/info-complementaria-web/info-complementaria-web.component';
import { FooterPrincipalComponent } from './pages/footer-principal/footer-principal.component';
import { RegistroExitosoComponent } from './pages/registro-exitoso/registro-exitoso.component';
import { OlvidoClaveComponent } from './pages/formulario-web/olvido-clave/olvido-clave.component';
import { BandejaNotifComponent } from './pages/bandeja-notif/bandeja-notif.component';
import { ModalMailDetalleComponent } from './pages/bandeja-notif/modal-mail-detalle/modal-mail-detalle.component';
import { DatosMovilComponent } from './pages/datos-movil/datos-movil.component';
import { ModalDetalleMovilComponent } from './pages/datos-movil/modal-detalle-movil/modal-detalle-movil.component';


// import { ModalMensajeFwComponent } from './pages/formulario-web/modal-mensaje-fw/modal-mensaje-fw.component';



@NgModule({
  declarations: [
    AppComponent,

    HechoIrregularComponent,
    DatosGeneralComponent,
    DenunciaContenedorComponent,
    EntidadHechoComponent,
    FuncionarioInvolucradoComponent,
    EmpresaInvolucradaComponent,
    PruebaHechoComponent,
    FormularioWebComponent,
    ModalMontoComponent,
    ModalEmpresaComponent,
    ModalEntidadComponent,
    ModalFuncionarioComponent,
    ContenedorDenuncianteComponent,
    ModalIrregInfobrasComponent,
    ModalMensajeComponent,
    ModalBusqObrpuComponent,
    PanelPrincipalComponent,
    BodyOpcionesComponent,
    BodyBusquedaComponent,
    PersonaJuridicaComponent,
    PersonaNaturalComponent,
    ModalNotificacionComponent,
    ContenedorMpComponent,
    ModalMpComponent,
    ModalContratacionComponent,
    ModalRegistroObraComponent,
    InstanciaComponent,
    ModalHechoIrregularComponent,
    EvidenciasComponent,
    FurComponent,
    ModalInstanciaComponent,
    ModalAntecedenteComponent,
    AntecedentesFurComponent,
    EvalinfRegfurComponent,
    DgHojaEvalComponent,

    BodyRegistroComponent,

    BodyDatosGeneralComponent,

    BodyDatosExpedienteComponent,

    BodyDatosOtrosComponent,

    ContenedorAsigInfoComponent,

    RegistroDocumentoComponent,

    AsignarInformacionComponent,

    DatosRegistroComponent,

    DgAsigRespComponent,

    AsignaResponsableComponent,


    ContenedorWebComponent,

    AgrupacionComponent,

    ExpedienteComponent,

    EvaluacionFudComponent,
    DocAGenerarComponent,

    DocumentosEmitidosComponent,


    NavModalComponent,

    BusqEntidadComponent,

    EncuestaComponent,

    ModalEncuestaComponent,

    ModalGuardarComponent,

    PanelPrincipalFwComponent,

    CabeceraPpFwComponent,

    AccedaDenunciaComponent,

    FooterPrincipalComponent,

    DatosEmpresaDenuncComponent,

    DenuncianteCongresistaComponent,

    PpPruebaComponent,

    ModalRepLegalComponent,

    DcianteEntidadPubComponent,

    ModalDatosEmpresaComponent,

    ModalVerRepreLegalComponent,

    ModalSeguimientoPpComponent,

    ModalTerminosComponent,

    ModalRegContratacionComponent,

    ModalBusqContratacionComponent,

    ModalRegHechoirreContrComponent,

    ModalDetalleContratacionComponent,

    FechaHoraMaterialComponent,

    DatosGenFurComponent,

    ModalRegCargoComponent,

    ModalGenerarDocSgdComponent,


    ModalBusqFurComplComponent,

    ModalTerminosComponent,

    ModalInstruccionesMpComponent,

    ModalAccesoComponent,

    InfoComplementariaWebComponent,

    RegistroExitosoComponent,

    RegistroExitosoComponent,

    OlvidoClaveComponent,

    BandejaNotifComponent,

    ModalMailDetalleComponent,

    DatosMovilComponent,

    ModalDetalleMovilComponent,

    // ModalMensajeFwComponent



  ],
  imports: [

    AppRoutingModule,
    BrowserAnimationsModule,
    MatInputModule,
    HttpClientModule,
    MatSlideToggleModule,
    BrowserModule,
    RecaptchaModule,
    CommonModule, // modulo para directivas angular ngModel
    FormsModule, // modulo para directivas angular ngModel
    ReactiveFormsModule, // modulo para directivas angular ngModel
    RouterModule.forRoot(router, {useHash: true}),
    // RouterModule.forRoot(router),
    MatDialogModule,
    NgxMaskModule.forRoot(options),
    MatIconModule,
    FontAwesomeModule,
    MatTooltipModule,
    MatTableModule,
    MatPaginatorModule
    ,
    NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule,
    MatDatepickerModule
     ,
     NgxMatMomentModule
     ,
     NgxSpinnerModule,
     SpeechSynthesisModule.forRoot({
      lang: 'es',
      volume: 5.0,
      pitch: 0.25,
      rate: 0.5,
    })
  ]
  ,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
  ,

  exports: [
    MatDialogModule
  ],
  entryComponents: [
    ModalMontoComponent,

    ContenedorDenuncianteComponent,
    // PersonaJuridicaComponent,
    // PersonaNaturalComponent,
    ModalNotificacionComponent,
    ContenedorMpComponent,
    // ModalMpComponent,
    ModalNotificacionComponent,
    ModalEmpresaComponent,
    ModalEntidadComponent,
    ModalFuncionarioComponent,
    ModalMensajeComponent,
    ModalBusqObrpuComponent,
    ModalIrregInfobrasComponent,
    ModalVerRepreLegalComponent,
    ModalSeguimientoPpComponent,
    ModalTerminosComponent,
    ModalAccesoComponent,
    ModalInstruccionesMpComponent,

    ModalDatosEmpresaComponent,

    ModalContratacionComponent,
    ModalRegistroObraComponent,

    ModalHechoIrregularComponent,
    ModalAntecedenteComponent,
    ModalInstanciaComponent,
    ModalEncuestaComponent,
    // ModalGuardarComponent,
    ModalRepLegalComponent,
    ModalRegContratacionComponent,
    ModalRegCargoComponent,

    ModalBusqContratacionComponent,

    ModalRegHechoirreContrComponent,

    ModalDetalleContratacionComponent,
    ModalGenerarDocSgdComponent,
    ModalBusqFurComplComponent,
    ModalMailDetalleComponent,
    ModalDetalleMovilComponent
  ],
  providers: [DatePipe,
             CookieService,
             // Location,
            // {provide: DateAdapter, useClass: MomentDateAdapter},
            // { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
            // { provide: LocationStrategy, useClass: HashLocationStrategy },
            // {provide: APP_BASE_HREF, useValue: '/my/app'},
            {provide: MAT_DATE_LOCALE, useValue: 'es-ES'}
          ],
  bootstrap: [AppComponent]
})
export class AppModule { }
